import { fromColorPathToColor, WeenatColor } from '@weenat/theme'
import type { PropsWithChildren, SVGProps } from 'react'

interface RippleProps extends SVGProps<SVGSVGElement> {
  tint?: WeenatColor
}

const RIPPLE_SIZE = 96

const Ripple: FC<PropsWithChildren<RippleProps>> = ({ tint, children, ...props }) => {
  const stroke = fromColorPathToColor(tint ?? 'grayscale.black')
  return (
    <Flex $position='relative'>
      <svg
        width={RIPPLE_SIZE}
        height={RIPPLE_SIZE}
        viewBox='0 0 96 96'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
      >
        <g mask='url(#mask0_12_12)' fill='transparent'>
          <rect x='28.5' y='28.5' width='39' height='39' rx='11.5' stroke={stroke} />
          <rect x='20.5' y='20.5' width='55' height='55' rx='15.5' stroke={stroke} />
          <rect x='12.5' y='12.5' width='71' height='71' rx='19.5' stroke={stroke} />
        </g>
        <mask
          id='mask0_12_12'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='96'
          height='96'
        >
          <circle cx='48' cy='48' r='48' fill='url(#paint0_radial_12_12)' />
        </mask>
        <defs>
          <radialGradient
            id='paint0_radial_12_12'
            cx='0'
            cy='0'
            r='1'
            gradientUnits='userSpaceOnUse'
            gradientTransform='translate(48 48) rotate(90) scale(48)'
          >
            <stop stopColor='white' stopOpacity='1' />
            <stop offset='0.5' stopColor='white' stopOpacity='0.25' />
            <stop offset='1' stopColor='white' stopOpacity='0' />
          </radialGradient>
        </defs>
      </svg>
      <Flex
        $position='absolute'
        style={{
          top: `${RIPPLE_SIZE / 2}px`,
          left: `${RIPPLE_SIZE / 2}px`,
          transform: 'translate(-50%, -50%)'
        }}
      >
        {children}
      </Flex>
    </Flex>
  )
}

export default Ripple
